import feedBackMethods from './Parent.feedback'

export const FeedbackServices = {
  ...feedBackMethods
}
